/* eslint-disable @next/next/no-img-element */
"use client";

import React, { useContext, useEffect, useState } from "react";
import { GrLinkedinOption, GrMail } from "react-icons/gr";
import { FaXTwitter } from "react-icons/fa6";
import Link from "next/link";
import { Hourglass } from "react-loader-spinner";
import { redirect, usePathname, useRouter } from "next/navigation";
import { BlogList } from "../../blog/BlogList";
import CategoryList from "../../blog/CategoryList";
import MarioLoader from "../../blog/MarioLoader";
import website_logo from "../../../../public/assets/blog/blog_logo/website_logo.webp";
import wrapcast_logo from "../../../../public/assets/blog/blog_logo/wrapcast_logo.webp";
import git_logo from "../../../../public/assets/blog/blog_logo/git_logo.webp";

import { useParams } from "next/navigation";
import Image from "next/image";
import MyContext from "../../Context/MyContext";

const Authorpage = () => {
    const { blogList, loadings } = useContext(MyContext);
    const router = useRouter();

    const currentPage = usePathname();
    const search = currentPage.split("/")[3];

    const params = useParams();
    const { slug } = params;

    const [FilteredBlogList, setFilteredBlogList] = useState([]);
    const [ifFilterBloge, setIfFilterBlog] = useState(false);
    const [tagList, setTagList] = useState([]);
    const [isValidAuthor, setIsValidAuthor] = useState(true);

    const autherBlog = blogList?.filter(
        (blog) =>
            blog?.attributes?.seo?.metaArticle?.authors[0]?.username === slug
    );

    useEffect(() => {
        if (!loadings && blogList.length > 0 && slug) {
            const authorExists = blogList.some((blog) =>
                blog?.attributes?.seo?.metaArticle?.authors[0]?.username === slug
            );

            if (!authorExists) {
                setIsValidAuthor(false);
                router.replace('/');
                return;
            }
        }
    }, [blogList, slug, loadings, router]);

    useEffect(() => {
        if (blogList && search) {
            const filteredBlogs = blogList?.filter((blog) =>
                blog?.attributes?.tags?.data?.some(
                    (tag) =>
                        tag?.attributes?.uid?.toLowerCase() ===
                        search?.toLowerCase()
                )
            );

            if (filteredBlogs?.length <= 0) {
                setIfFilterBlog(true);
            }
            setFilteredBlogList(filteredBlogs);
        } else {
            setFilteredBlogList([]);
        }
    }, [search, blogList]);

    useEffect(() => {
        if (blogList.length > 0) {
            const allTags = blogList
                .flatMap((blog) => blog.attributes.tags?.data || [])
                .map((tag) => ({
                    name: tag.attributes.name,
                    uid: tag.attributes.uid,
                }));

            // Remove duplicate tags
            const uniqueTags = Array.from(
                new Map(allTags.map((tag) => [tag.uid, tag])).values()
            );

            setTagList(uniqueTags);
        }
    }, [blogList]);

    // Show message if invalid author
    if (!isValidAuthor) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="text-center">
                    <h2 className="text-2xl font-bold mb-4">Author not found</h2>
                    <p className="text-gray-600 mb-4">Redirecting to home page...</p>
                    <MarioLoader />
                </div>
            </div>
        );
    }

    return (
        <>
            {loadings ? (
                <div className="flex justify-center items-center aligncenter my-96">
                    <MarioLoader />
                </div>
            ) : (
                <div className="flex flex-col w-full min-h-screen">
                    <div className="flex flex-col items-center w-full place-content-center text-white">
                        <div
                            className="w-full py-32"
                            style={{
                                backgroundColor: `${autherBlog?.length > 0
                                    ? autherBlog[0]?.attributes
                                        ?.backgroundColor
                                    : blogList[0]?.attributes
                                        ?.backgroundColor
                                    }`,
                            }}
                        >
                            <div className="grid items-center place-items-center place-content-center w-full grid-cols-1 gap-6 md:grid-cols-2 container mx-auto">
                                <div className="grid w-full gap-3 text-md">
                                    <p className="font-medium md:text-left text-center">
                                        Latest Guide
                                    </p>
                                    <h1 className="w-full text-6xl font-semibold text-center md:text-left text-white drop-shadow-sm md:mb-4 lg:leading-[70px]">
                                        {autherBlog?.length > 0
                                            ? autherBlog[0]?.attributes?.title
                                            : blogList[0]?.attributes?.title}
                                    </h1>

                                    <div className="md:text-start text-center">
                                        {autherBlog?.length > 0
                                            ? autherBlog[0]?.attributes?.seo
                                                    ?.metaDescription
                                            : blogList[0]?.attributes?.seo
                                                    ?.metaDescription}
                                    </div>

                                    <p className="text-white hover:text-gray-400 cursor-pointer w-fit">
                                        <Link
                                            href={
                                                autherBlog &&
                                                        autherBlog?.length > 0
                                                    ? `${process.env.NEXT_PUBLIC_BLOG_URL}/blog/${autherBlog[0]?.attributes?.slug}`
                                                    : `${process.env.NEXT_PUBLIC_BLOG_URL}/blog/${blogList[0]?.attributes?.slug}`
                                            }
                                            target="_top"
                                            className="common-white-button-style"
                                        >
                                            {"Read More"}
                                        </Link>
                                    </p>

                                    <div className="flex items-center justify-center md:justify-start gap-x-4 md:mt-10">
                                        <p className="font-semibold text-center md:text-start leading-[18px] text-xl">
                                            <span className="truncate capitalize">
                                                {autherBlog[0]?.attributes?.seo?.metaArticle?.authors?.map(
                                                    (author, authorIndex) => {
                                                        return (
                                                            <span
                                                                key={
                                                                    authorIndex
                                                                }
                                                                className="text-white"
                                                            >
                                                                {
                                                                    author.firstName
                                                                }{" "}
                                                                {
                                                                    author.lastName
                                                                }
                                                                {authorIndex ===
                                                                    blogList[0]
                                                                        ?.attributes
                                                                        ?.seo
                                                                        ?.metaArticle
                                                                        ?.authors
                                                                        ?.length -
                                                                    1
                                                                    ? ""
                                                                    : " "}
                                                            </span>
                                                        );
                                                    }
                                                )}
                                            </span>
                                        </p>

                                        <div className="h-2 w-2 bg-white rounded-full"></div>

                                        <p className="font-semibold text-center md:text-start tabular-nums truncate">
                                            <span className="text-white text-xl">
                                                {autherBlog[0]?.attributes?.seo
                                                    ?.metaArticle
                                                    ?.publishedTime && (
                                                            <>
                                                                {new Date(
                                                                    blogList[0].attributes?.seo?.metaArticle?.publishedTime
                                                                ).toLocaleString(
                                                                    "default",
                                                                    {
                                                                        month: "long",
                                                                    }
                                                                )}{" "}
                                                                {new Date(
                                                                    blogList[0].attributes?.seo?.metaArticle?.publishedTime
                                                                ).getDate()}
                                                                ,{" "}
                                                                {new Date(
                                                                    blogList[0].attributes?.seo?.metaArticle?.publishedTime
                                                                ).getFullYear()}
                                                            </>
                                                        )}
                                            </span>
                                        </p>
                                    </div>

                                    {/* Social links */}
                                    <div className="flex items-center justify-center gap-4 text-xl md:justify-start text-white">
                                        {autherBlog[0]?.attributes?.seo
                                            ?.metaArticle?.authors[0]
                                            ?.firstName === "Anandi" ? (
                                            <>
                                                {" "}
                                                {/* Personal website */}
                                                <Link
                                                    href="https://www.anandisheladiya.com"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={website_logo}
                                                        alt="website_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* github */}
                                                <Link
                                                    href="https://github.com/CodebyAnandi"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={git_logo}
                                                        alt="git_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* linkedin */}
                                                <a
                                                    href="https://www.linkedin.com/in/anandi-sheladiya-200893101/"
                                                    target="_blank"
                                                >
                                                    <GrLinkedinOption className="cursor-pointer text-2xl" />
                                                </a>
                                                {/* twitter */}
                                                <a
                                                    href="https://x.com/Anandi_007"
                                                    target="_blank"
                                                >
                                                    <FaXTwitter className="cursor-pointer  text-2xl" />
                                                </a>
                                                {/* wrapcast */}
                                                <Link
                                                    href="https://warpcast.com/anandi"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={wrapcast_logo}
                                                        alt="wrapcast_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* gmail */}
                                                <a
                                                    href="mailto:solve@tanthetaa.com"
                                                    target="_blank"
                                                >
                                                    <GrMail className="cursor-pointer  text-2xl" />
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                {" "}
                                                {/* Personal website */}
                                                <Link
                                                    href="https://www.mohitkapadiya.com"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={website_logo}
                                                        alt="website_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* github */}
                                                <Link
                                                    href="https://github.com/codebyMoh"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={git_logo}
                                                        alt="git_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* linkedin */}
                                                <a
                                                    href="https://www.linkedin.com/in/mohit-kapadiya-mohtajj-eth-0110b7232"
                                                    target="_blank"
                                                >
                                                    <GrLinkedinOption className="cursor-pointer  text-2xl" />
                                                </a>
                                                {/* twitter */}
                                                <a
                                                    href="https://x.com/Mohtajj95"
                                                    target="_blank"
                                                >
                                                    <FaXTwitter className="cursor-pointer  text-2xl" />
                                                </a>
                                                {/* wrapcast */}
                                                <Link
                                                    href="https://warpcast.com/mohitkapadiya"
                                                    target="_blank"
                                                >
                                                    <Image
                                                        src={wrapcast_logo}
                                                        alt="wrapcast_logo"
                                                        className="cursor-pointer text-2xl"
                                                    />
                                                </Link>
                                                {/* gmail */}
                                                <a
                                                    href="mailto:solve@tanthetaa.com"
                                                    target="_blank"
                                                >
                                                    <GrMail className="cursor-pointer  text-2xl" />
                                                </a>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <img
                                        layout="fill"
                                        className="object-fill p-1 transition-all duration-300 ease-in-out rounded-3xl"
                                        src={
                                            autherBlog && autherBlog?.length > 0
                                                ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${autherBlog[0]?.attributes?.image?.data?.attributes.url}`
                                                : `${process.env.NEXT_PUBLIC_STRAPI_URL}${blogList[0]?.attributes?.image?.data?.attributes.url}`
                                        }
                                        alt={
                                            autherBlog?.length > 0
                                                ? autherBlog[0]?.attributes
                                                    ?.title
                                                : blogList[0]?.attributes?.title
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="gradient-border mx-auto md:mt-16 mt-8"></div>

                    <div className="container mx-auto">
                        <div className="text-center md:mt-16 mt-8 ">
                            <h2
                                className={`text-2xl lg:text-5xl !leading-snug font-bold font-manrope text-[#410EAD] `}
                            >
                                Most&nbsp;
                                <span className={`text-black font-manrope`}>
                                    Popular Tags
                                </span>
                            </h2>
                        </div>

                        <div className="flex flex-col items-center w-full px-3 py-12 my-5 ">
                            <CategoryList
                                tags={tagList}
                                activeTags={search}
                                FilteredBlogList={FilteredBlogList}
                                setFilteredBlogList={setFilteredBlogList}
                                blogList={autherBlog}
                                setIfFilterBlog={setIfFilterBlog}
                            />
                        </div>

                        <div className="flex flex-col items-center w-full py-3 ">
                            {FilteredBlogList?.length <= 0 ? (
                                ifFilterBloge ? (
                                    <div className="text-3xl font-bold">
                                        No Data Found
                                    </div>
                                ) : (
                                    <BlogList blogList={autherBlog} />
                                )
                            ) : (
                                <BlogList blogList={FilteredBlogList} />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Authorpage;
